import React from "react";
import PropTypes from "prop-types";
import {
    Modal,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../styles/component/model.scss"

const ModelComponent = ({ open, width = 550, onClose, title, children, actions, className }) => {
    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: width,
        padding: "20px",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 3,
        borderRadius: "10px",
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            className="common-model"
        >
            <Box sx={modalStyle} className={`${className} modal-data`}>
                {/* Modal Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography id="modal-title" variant="h6" component="h2" className={`${className} model-title`} >
                        {title}
                    </Typography>
                    <IconButton onClick={onClose} sx={{ border: "1.5px solid #000", height: " 20px", width: "20px", background: "#fff" }}>
                        <CloseIcon sx={{ padding: "7px", color: "#000" }} />
                    </IconButton>
                </Box>
                {/* Modal Content */}
                <Box id="modal-description" sx={{ marginTop: "20px " }}>{children}</Box>

                {/* Modal Actions */}
                {actions && (
                    <Box
                        mt={2}
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                    >
                        {actions}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

ModelComponent.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    actions: PropTypes.node,
};

export default ModelComponent;